var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1019_24243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 5.3335C17.78 5.3335 5.83337 17.2802 5.83337 32.0002C5.83337 46.7202 17.78 58.6668 32.5 58.6668C47.22 58.6668 59.1667 46.7202 59.1667 32.0002C59.1667 17.2802 47.22 5.3335 32.5 5.3335ZM27.1667 45.3335L13.8334 32.0002L17.5934 28.2402L27.1667 37.7868L47.4067 17.5468L51.1667 21.3335L27.1667 45.3335Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1019_24243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circleCheck.532d9f796e94bffd5749cfdc7c62020b.svg";
export { ForwardRef as ReactComponent };